import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { inputCls, btnPrimary, dialogCls, errMsg } from "./shared";

export function RegisterBusinessDialog({ open, onClose, fee, credits, onDone, categories = [] }) {
  const [f, setF] = useState({ name: "", gender: "", age: "", location: "", category: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (fee > 0 && !window.confirm(`${fee} Credits will be deducted to send your business for approval. Continue?`)) return;
    setBusy(true);
    try {
      await api.post("/market/business/register", { ...f, age: Number(f.age) });
      toast.success("Business sent to admin for approval");
      onDone();
      onClose();
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className={dialogCls} data-testid="register-business-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-sky-950">Register as a business</DialogTitle>
          <DialogDescription className="text-sky-700">
            {fee > 0 ? `Fee: ${fee} Credits (you have ${credits}).` : "Free to register."} Admin approves before you go live.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <input data-testid="register-name" className={inputCls} placeholder="Business or your name" value={f.name} onChange={set("name")} required />
          <select data-testid="register-gender" className={inputCls} value={f.gender} onChange={set("gender")} required>
            <option value="">Gender</option><option>Male</option><option>Female</option><option>Other</option>
          </select>
          <input data-testid="register-age" type="number" min="13" max="120" className={inputCls} placeholder="Age" value={f.age} onChange={set("age")} required />
          <select data-testid="register-category" className={inputCls} value={f.category} onChange={set("category")} required>
            <option value="">Category</option>
            {categories.map((c) => <option key={c}>{c}</option>)}
          </select>
          <input data-testid="register-location" className={inputCls} placeholder="Location (e.g. Accra - Madina)" value={f.location} onChange={set("location")} required />
          <button data-testid="register-submit" type="submit" className={`${btnPrimary} w-full`} disabled={busy}>
            {busy ? "Submitting…" : "Send for approval"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
